import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Reveal, SectionLabel } from "../components/Reveal";

const FAQS = [
  {
    q: "Quanto costa realizzare un sito?",
    a: "Dipende dalla struttura, dal numero di contenuti e dalle funzionalità richieste. Dopo aver capito cosa serve alla tua attività riceverai una proposta chiara prima dell'inizio del lavoro.",
  },
  {
    q: "Posso vedere qualcosa prima di decidere?",
    a: "Sì. Prepariamo una prima bozza gratuita e limitata che ti permette di valutare concretamente la direzione grafica del progetto prima di procedere con la realizzazione completa.",
  },
  {
    q: "Il sito rimane mio?",
    a: "Sì. Al termine del progetto riceverai gli accessi necessari alla gestione della tua infrastruttura e potrai scegliere liberamente come gestire il sito in futuro.",
  },
  {
    q: "Sono obbligato a pagare DS LAB STUDIO ogni anno?",
    a: "No. Dominio, hosting ed eventuali servizi necessari al funzionamento del sito sono intestati e sostenuti dal cliente. Eventuali servizi di gestione e assistenza di DS LAB STUDIO sono separati.",
  },
  {
    q: "Posso chiedere modifiche dopo la pubblicazione?",
    a: "Sì. Puoi richiedere singoli interventi oppure concordare un servizio di gestione e aggiornamento.",
  },
  {
    q: "Posso inserire prenotazioni o richieste di appuntamento?",
    a: "Sì. In base alle esigenze dell'attività possiamo integrare sistemi di prenotazione, moduli di richiesta o collegamenti ad altri strumenti utilizzati dal cliente.",
  },
  {
    q: "Posso avere WhatsApp sul mio sito?",
    a: "Sì. Quando utile possiamo inserire un collegamento diretto a WhatsApp, anche con messaggio preimpostato.",
  },
  {
    q: "Posso utilizzare un dominio che possiedo già?",
    a: "Sì. Se disponi già di un dominio possiamo valutare la configurazione sul nuovo sito.",
  },
];

export const Faq = () => (
  <section id="faq" aria-labelledby="faq-title" className="bg-white">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="grid gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <SectionLabel>FAQ</SectionLabel>
          <h2 id="faq-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-navy-dark sm:text-4xl">
            Domande frequenti.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-steel">
            Le risposte alle domande più comuni su come lavoriamo e su come viene gestito il tuo
            progetto.
          </p>
        </Reveal>
        <Reveal className="lg:col-span-8" delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((faq, i) => (
              <AccordionItem key={faq.q} value={`faq-${i}`} className="border-line">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-display text-base font-semibold text-navy-dark hover:text-navy hover:no-underline sm:text-lg"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-steel sm:text-base">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
